import { SubmitIconType } from "@/api/useIntegrations.types"
import { ExternalLinkOutlined, ReadOutlined } from "@/icons"

export const LinkIcon = ({ type }: { type: SubmitIconType }) => {
  return type === "default" ? <ReadOutlined /> : <ExternalLinkOutlined />
}
